module.exports = __webpack_public_path__ + "static/img/preview-06.39d4df9b.webp";